var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52493 11.6676C7.19993 11.1926 7.0166 10.6176 7.0166 10.0009C7.0166 8.35091 8.34993 7.01758 9.99993 7.01758C11.6499 7.01758 12.9833 8.35091 12.9833 10.0009C12.9833 11.6509 11.6499 12.9842 9.99993 12.9842",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6332 4.64909C13.2249 3.64909 11.6415 3.10742 9.99987 3.10742C7.0582 3.10742 4.31654 4.84076 2.4082 7.84076C1.6582 9.01576 1.6582 10.9908 2.4082 12.1658C4.31654 15.1658 7.0582 16.8991 9.99987 16.8991C12.9415 16.8991 15.6832 15.1658 17.5915 12.1658C18.3415 10.9908 18.3415 9.01576 17.5915 7.84076",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenEye);
export default __webpack_public_path__ + "static/media/brokenEye.93fce15623a9a217fbd9e2815efe460d.svg";
export { ForwardRef as ReactComponent };